import { useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useRegency() {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  const refetch = (province_id?: string) => {
    setLoading(true)

    api.get("/regencies/", {
      params: { province_id: province_id }
    }).then((res: SuccessFetch<{
      payload: {
        regency_id: string
        regency_name: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: item.regency_name,
          value: item.regency_id
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
  }

  return { data, isLoading, refetch }
}